import { Gavel, Users, Ban, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
const datos = [{
  icon: Gavel,
  title: "De multa a cárcel",
  desc: "El Art. 62 reformado establece penas de 2 a 8 años de prisión. Ya no solo por dolo — ahora también por negligencia, descuido o información ilegible. Aplica a cualquier sujeto obligado, sin importar el giro."
}, {
  icon: Users,
  title: "Cada parte debe cumplir",
  desc: "Si eres broker, inmobiliaria, desarrolladora, agente aduanal o cualquier otro intermediario: el KYC de la notaría ya no te cubre. La ley exige que cada participante tenga su propio expediente de identificación."
}, {
  icon: Ban,
  title: "Multas de hasta $7.3M MXN",
  desc: "Las sanciones administrativas van de $22,628 a $7,354,100 MXN. Y ahora la SHCP puede suspender temporalmente tus operaciones mientras investiga — sin importar si eres notaría, joyería o cualquier otro sujeto obligado."
}];
export default function AlertaReforma() {
  return <section data-section-id="REEMPLAZAR" id="alerta-reforma" className="bg-[#020617] text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 flex flex-col items-center text-center">
          <Badge variant="outline" className="mb-4 border-amber-600/30 text-amber-600 font-mono">
            Reforma DOF · 16 de julio de 2025
          </Badge>
          <h2 className="font-default text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl max-w-4xl">
            La reforma de julio 2025 cambió las reglas del juego{" "}
            <span className="text-amber-600 font-mono">para todos los sujetos obligados</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {datos.map((dato, i) => {
          const Icon = dato.icon;
          return <div key={dato.title} data-index={i} className="p-6 md:p-8 rounded-lg border-2 border-amber-600/20 bg-card hover:border-amber-600/40 transition-colors">
                <div className="size-12 rounded-md bg-amber-600/10 flex items-center justify-center mb-5">
                  <Icon className="size-6 text-amber-600" strokeWidth={1.5} />
                </div>
                <h3 className="font-default text-xl font-bold text-white mb-3">{dato.title}</h3>
                <p className="font-default text-sm text-slate-400 leading-relaxed">{dato.desc}</p>
              </div>;
        })}
        </div>
        <div className="mt-12 flex flex-col items-center gap-4">
          <Link to="#">
            <span className="inline-flex items-center gap-2 text-sm font-mono uppercase tracking-widest text-amber-600 hover:underline">
              Conoce las nuevas obligaciones
              <ArrowRight className="size-4" />
            </span>
          </Link>
          <p className="text-xs text-muted-foreground font-mono text-center max-w-2xl">
            Decreto DOF 16 de julio de 2025. Reforma a la LFPIORPI y Art. 400 Bis del Código Penal Federal.
          </p>
        </div>
      </div>
    </section>;
}